import React, { useState, useContext } from "react";
import { AppContext } from "../contexts/AppContext";
import axiosHttp from "../config/axios.interceptor";
import { useDispatch } from "react-redux";
import { getActiveNotificationCount } from "../store/actions/notificationAction";
import moment from "moment";
import { getActiveChatNotificationCount } from "../store/actions/chatNotificationAction";
import { AuthContext } from "../contexts/AuthContext";
import { errorResponseMessage } from "../shared/const.prop";

const QueryReply = ({ data }) => {
  const [reason, setReason] = useState("");
  const appContext = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const dispatch = useDispatch();

  const replyQuery = async (val) => {
    let payload = {};
    if (data.category !== "Freelancing services") {
      payload = {
        queryId: data?.id,
        serviceId: data?.serviceId,
        receiverId: data?.senderId,
        message: reason,
        isActive: val,
        category: data.category,
      };
    } else {
      payload = {
        queryId: data?.id,
        category: data?.category,
        receiverId: data?.senderId,
        message: reason,
        isActive: val,
      };
    }
    try {
      const getReply = await axiosHttp.post(`queries/reply`, {
        ...payload,
      });
      if (getReply.status === 201) {
        dispatch(getActiveNotificationCount());
        dispatch(getActiveChatNotificationCount());
        appContext.updateModalState();
      }
    } catch (e) {
      if (e.response.status === 429) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
        authContext.logout();
      }
      if (e.response.status === 400) {
        appContext.updateNotificationState({
          show: true,
          message: errorResponseMessage(e),
          type: "error",
        });
      }
      if (e.response?.status >= 500) {
        appContext.updateNotificationState({
          show: true,
          message: "Something went wrong, please try again later.",
          type: "error",
        });
      }
      //console.log(e);
    }
  };

  const startDate = moment(data?.start_date).format("DD MMM YYYY");
  const endDate = moment(data?.end_date).format("DD MMM YYYY");

  return (
    <div className="card-body">
      <div className={`row `}>
        {data?.category !== "Freelancing services" ? (
          <p>
            I need your assistance in {data?.expertise} So I would like to book{" "}
            {data?.serviceName === "Single session"
              ? data?.serviceName
              : data?.duration}{" "}
            session{" "}
            {startDate !== "Invalid date" &&
              endDate !== "Invalid date" &&
              `(${startDate} - ${endDate})`}
          </p>
        ) : (
          <p>{data?.category}</p>
        )}
      </div>
      <div className="row mt-1">message: {data?.message}</div>
      <div className="row mt-1 mb-3">
        <textarea
          className="form-control box-col"
          id=""
          rows="5"
          placeholder="Comment"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
        ></textarea>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="d-flex mt-4">
            <button
              type="button"
              className="btn btn-primary modal-btn"
              disabled={reason === ""}
              onClick={() => replyQuery(true)}
            >
              Accept
            </button>
            <button
              type="button"
              className="btn btn-outline-primary prime-btn mx-3"
              disabled={reason === ""}
              onClick={() => replyQuery(false)}
            >
              Reject
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QueryReply;
